{
	"abilities": {
		"admins_manage": "Manage admins"
	},
	"actions": {
		"edit_abilities": "Edit abilities",
		"open_menu": "Open actions menu",
		"request_password_reset": "Request password reset",
		"resend_invite": "Resend invite email"
	},
	"columns": {
		"abilities": "Abilities",
		"actions": "Actions",
		"id": "ID",
		"status": "Status"
	},
	"delete_admin": {
		"description": "Permanently delete the account for {{email}}. This action cannot be undone.",
		"success": "Admin account deleted.",
		"title": "Delete admin account"
	},
	"edit_abilities": {
		"description": "Update the abilities granted to {{email}}.",
		"submit": "Save abilities",
		"success": "Abilities updated.",
		"title": "Edit admin abilities"
	},
	"filters": {
		"field": {
			"abilities": "Abilities"
		}
	},
	"invite": {
		"abilities": "Abilities",
		"abilities_placeholder": "Select abilities",
		"abilities_search_empty": "No ability found",
		"button": "Invite admin",
		"description": "Send an invitation email to a new admin user.",
		"email_placeholder": "name@example.com",
		"error": "Failed to invite admin.",
		"name_placeholder": "Full name",
		"submit": "Send invite",
		"success": "Admin invited successfully.",
		"title": "Invite a new admin",
		"validation": {
			"abilities_invalid": "Select at least one ability",
			"email_invalid": "Enter a valid email",
			"name_invalid": "Name is required"
		}
	},
	"page_title": "Admins",
	"request_password_reset": {
		"confirm": "Send reset link",
		"description": "Send a password reset link to {{email}}. The current password will remain valid until they pick a new one.",
		"success": "Password reset link sent.",
		"title": "Request password reset"
	},
	"resend_invite": {
		"confirm": "Resend invite",
		"description": "Resend the invitation email to {{email}}. The previous link will be invalidated.",
		"success": "Invite resent.",
		"title": "Resend invite email"
	},
	"search_placeholder": "Search admin...",
	"status": {
		"active": "Active",
		"pending": "Pending invite"
	},
	"empty_title": "No admins",
	"empty_description": "Invite a team member to give them access."
}
